import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use((config) => {
  const baseURL = config.baseURL ?? "";
  const url = config.url ?? "";

  console.log("BLOG API REQUEST");
  console.log("URL:", baseURL + url);
  console.log("Params:", config.params);

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("BLOG API ERROR:", {
      status: error.response?.status,
      url: error.response?.config?.url,
      params: error.response?.config?.params,
      data: error.response?.data,
    });

    return Promise.reject(error);
  }
);

export interface GetBlogsParams {
  page?: number;
  limit?: number;
  category?: string;
  q?: string;
}

export interface BlogsResponse {
  data: any[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const getBlogs = async ({
  page = 1,
  limit = 5,
  category,
  q,
}: GetBlogsParams = {}): Promise<BlogsResponse> => {
  const { data } = await API.get("/blog", {
    params: {
      page,
      limit,
      status: "published",
      ...(category ? { category } : {}),
      ...(q ? { q } : {}),
    },
  });

  return data;
};

export interface BlogDetailResponse {
  success: boolean;
  data: any;
}

export const getBlogByIdOrSlug = async (
  idOrSlug: string
): Promise<BlogDetailResponse> => {
  const { data } = await API.get(`/blog/${idOrSlug}`);
  return data;
};